<div class="detail-card" [class.detail-card--dividers]="dividers">
  <ng-content></ng-content>
</div>
